var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170 340",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6C22",
    d: "M64.61,119.42c8.2,2.6,13,8.6,16.1,16.4c6.5,16.6,13.1,33.1,19.7,49.7c3.2,8,7.3,15.6,11.1,23.3 c3.8,7.8,7,15.8,5.7,24.8c-0.4,2.5-1.3,4.8-2.8,6.8c-2,2.5-2.4,5.4-2.5,8.5s1.3,5.4,4.4,6.1c3,0.8,5.1-0.8,6.5-3.2 c0.8-1.4,1.3-2.9,2.1-4.7c3.5,4,5.1,8.9,6.2,13.8c2.9,12.4,3.5,24.9,0.3,37.4c-1.9,7.3-1.3,14.9-2.4,22.3 c-0.6,3.9-1.3,7.6-3.2,11.1c-4.2,7.8-12.4,9.6-19.5,4.1c-6.3-4.8-10.6-11.3-14.4-18c-14.2-25.3-24.9-52-30.6-80.4 c-4.4-22.1-2-44,4.8-65.4c0.1-0.3,0.4-0.6,0.7-1.3c2.7,3.4,6.5,3.8,10.3,3.8c1.1,0,2.4,0.2,1.8-1.7c-2.2-6.7-1.3-13.6-0.7-20.4 c0.9-9.2-2.7-16.6-9.1-22.8c-4.3-4.1-8.9-4-13.3,0.1c-4.5,4.2-6.9,9.7-9.3,15.2c-0.6,1.5-1.2,2.9-1.9,4.7 c-1.2-12.6,3.7-23.8,13.1-30.1C60.11,119.42,62.31,119.42,64.61,119.42z"
  }, /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a1",
    begin: "0ms;a14.end",
    fill: "freeze",
    attributeName: "d",
    to: "M114.69,338.48c0,0-8.7,8.3-25-41.2s-36.6-34.9-33.3-75.7s9.1-37.4,12.5-24.1c3.3,13.3,18.4,7.1,16.5-23.3 c-1.9-30.4-7.7-40.3-14.4-35.3c-6.7,5-12.1,25-10,35.3c2.1,10.4-11.5-8.3-4.9-36.6s10.8-39.9,20.7-13.3c10,26.6,7.6,39.9,21.1,60.7 s16.8,13.1,24.7,39.6s-34.9-25.5-20.4,17.4s24,12.5,21.4,0s12.8,1.4,20.1,46.9C143.59,288.98,146.59,327.88,114.69,338.48z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a2",
    begin: "a1.end",
    fill: "freeze",
    attributeName: "d",
    to: "M114.58,338.9c0,0-28.4,0.8-33.6-38.5s-29.1-40-32.9-80.1s10.3-47.3,16.8-29.8s28.4-23.8,9.7-52.2 s-15.5-17.4-14.9-5.8s-19.2-49.1-6.4-31s22.5,20.7,42.5,82s-11.6-24.5-11.6,30s26.5,20.5,24.5,11.1c-1.9-9.4,11-21.7,26.5,57.7 C135.28,282.2,150.78,326.4,114.58,338.9z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a3",
    begin: "a2.end",
    fill: "freeze",
    attributeName: "d",
    to: "M114.57,338.43c0,0-39.6-8-39.6-44.4s-6.3-38.8-23.7-45.1s-10.3-103.7,5.5-68.9s17.4-28.5,26.1-21.4 c8.7,7.1,19.8,9.5,19.8,32.5c0,0,0.4,4.8-6.7-2.5s-22.4,9.9-13.4,27.8s21.3-4.6,22.1-11.9c0.7-7.3,9.4-10.2,22.4,29.4 c13,39.7-12.3,58.4-4.3,84.4S114.57,338.43,114.57,338.43z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a4",
    begin: "a3.end",
    fill: "freeze",
    attributeName: "d",
    to: "M113.84,338.87c0,0-47.5-10.3-43.5-57.2s-28.6-34.8-35.5-68s6.3-67,18.3-43.5s25.2-5.1,24-13.2 c-1.1-8-0.4-14.5,13.9,2.1c14.3,16.7,11,25.7,11,25.7s-7.6-18.1-14.3-1s-15.2-1-10.5,15.7c4.8,16.7,17.1,20,19.1-2.4 c1.9-22.4,15-13.1,23.5-1.1s13.4,64.7,0,80.2S151.14,328.77,113.84,338.87z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a5",
    begin: "a4.end",
    fill: "freeze",
    attributeName: "d",
    to: "M114.08,338.81c0,0-52.7-3.6-55.8-66.3s-10.6-80-19.2-62.2c-8.6,17.8-9.1,0.1-10.6-23.2s13.9-61.5,27.6-25 s-2,45.7,24.5,39.6c26.5-6.1,34.9-42.6,12.8-31.2c-22.1,11.4,0.8-60.9,25.1-5.3c24.4,55.6-16.8,67.8,6.9,118.8 S114.08,338.81,114.08,338.81z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a6",
    begin: "a5.end",
    fill: "freeze",
    attributeName: "d",
    to: "M114.8,339c0,0-41.4-3-58.2-58.2s-2.4-105-18-92.4c-15.6,12.6-11.4,15-13.8-21.6s-4.8-60,12.6-36 s18.8,7.8,25.2,22.8s6.1,19.2-7.5,8.6c-13.5-10.7-17.1,0.7-5,18.9s60.9,33.1,58.4-3.6s-21-19.2-24.2-15.3s-13.9-10.7-8.2-20.3 s34.9-22.5,42.1,11.8c7.1,34.2-26.4,50.2-7.5,82.1S156.6,330.7,114.8,339z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a7",
    begin: "a6.end",
    fill: "freeze",
    attributeName: "d",
    to: "M119.15,338.08c0,0-27.1,8.4-46.8-31.6s-29.5-68.6-16-78.3s-17.8-44.1-19.7-35.5 c-1.9,8.6-4.3,17.8-8.6-13.5s-0.6-78.7,8-53.5s19.1,9.8,27.7,25.2s9.8,20.9,0,15.4s-26.4-8.6-4.9,16.6s50.4,14.8,52.3-2.5 c1.8-17.2-11.1-26.4-22.1-22.1c-11.1,4.3-11.1-15.4-3.7-21.5c7.4-6.1,52.4-2.5,33.9,54.7s17.1,48,16.5,91 S137.05,334.68,119.15,338.08z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a8",
    begin: "a7.end",
    fill: "freeze",
    attributeName: "d",
    to: "M121.98,339c0,0-7.7-12.4-29.4-14.7c-21.6-2.3-47.2-41-48.7-70.4s17.4-40.1,2.3-69.1 c-15.1-28.9-34.6-119-5.3-57.5c0,0,15.5,39.9,2.9,17.9s-9.4,13,9,44c18.3,31,65.2,0.8,58.3-22.4s-9-23.6-22.4-22 c-13.4,1.6-3.7-30.2,12.2-26.9s23,57.4,8.8,75.7c-14.1,18.3-10,38.3,15.9,54.2C151.48,263.8,144.98,327.1,121.98,339z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a9",
    begin: "a8.end",
    fill: "freeze",
    attributeName: "d",
    to: "M124.11,338.79c0,0-27.4-38.2-34.7-24.2s-5.6,6.7-18.5-8.4c-12.9-15.1-31.3-61.6-23.5-83.7 s-5.6-53.9-11.2-64c-5.6-10.1-16.8-48.7,0-25.2l6.8,13.4c0,0-23.5-36.2-5.4,11.2s45.6,56.2,65.6,33.8c20-22.5,9.8-56.1,1.1-58.2 c-8.8-2.1-20.5-28.5-6.6-17.7s30.2,39.2,11.6,71.8s35.4,48.1,33.3,87.6C140.71,314.59,127.11,341.69,124.11,338.79z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a10",
    begin: "a9.end",
    fill: "freeze",
    attributeName: "d",
    to: "M124.01,338.01c0,0-7.8,7.1-12.3-16.8c-4.5-24-26.6-60.3-33.7-20.7c0,0-29.8-24.6-26.6-55.7s11-44.7,5.8-59 c-5.2-14.2,19.5,13.6,39.6-6.5c11.2-11.2,31.6,14.6,40.1,53.3c-30.1-163.7-37.2-121.9-37.2-121.9l-4.9-23.1 c16.1-27.4,44.2,155.6,45,160.9c-0.2-1.3-0.4-2.5-0.7-3.8C143.21,273.41,140.61,307.21,124.01,338.01z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a11",
    begin: "a10.end",
    fill: "freeze",
    attributeName: "d",
    to: "M52.34,220.6c10.7-45.6,35.8-25.2,38.2-44.4c0.8-6.5-3.1-13-3.4-18.8c21.5,14.4,37.9,32.5,43.5,58.7 c1.1,13.7-0.7,28.1,6.4,40.6c7.1,14,6.2,27.9,1.3,42c-4.3,9.1-19.2,53.6-28.3,29.4c-4.7-13.8-23.1-50-32.6-19.9 C70.84,278.1,48.04,252.9,52.34,220.6z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a12",
    begin: "a11.end",
    fill: "freeze",
    attributeName: "d",
    to: "M63.19,156.9c4.4-6.5,10-8.7,16.8-7.1c0.7,0.2,1.5,0.3,2.2,0.6c18.1,8.8,31.8,21.4,36.2,42 c1.4,6.6-0.8,12.9-1.5,19.3c-0.6,5.3-0.6,10.5,0.5,15.7c1.2,5.8,4.1,10.5,9.5,13.7c8.2,5,9.9,13.4,10.5,22.1 c0.8,10.9-1.4,21.2-6.6,31.1c-6.9,13.1-9.8,27.7-13.4,41.9c-0.2,0.9,0.1,2.3-0.9,2.7c-1.3,0.5-1.9-1-2.6-1.7 c-11-10.8-21.2-22.2-29.8-35.1c-6.8-10.3-12.2-21.1-12.9-33.8c-0.9-14.6-4.9-28.7-7.4-43.1c-0.6-3.3-0.8-6.7-1.2-10 c-0.8-7.9,1.8-14.4,7.5-19.9c7.4-7.1,12.1-15.8,13.8-26c0.3-1.8,0.5-3.7,0.4-5.6c-0.1-5.6-3.2-8.7-8.9-9 C71.29,154.4,67.49,155.7,63.19,156.9z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a13",
    begin: "a12.end",
    fill: "freeze",
    attributeName: "d",
    to: "M53.71,169.14c-5.7-12.3-2-24.1,9.2-30.3c6-3.4,11.3-2.8,16.6,1.7c2.2,1.9,4.1,4.1,5.6,6.5 c7.8,12.7,13.5,26.4,17.9,40.6c1.9,6.2,1.2,12.6,1.8,19c0.4,4.4,2,7.8,5.4,10.7c5.3,4.4,7.8,10.2,8.4,17c0.2,1.7,0.2,2.7-2.2,3.1 c-4.6,0.9-7.5,4.3-8.7,8.9c-1.1,4.1,4.4,7.8,9.3,6.4c2.4-0.7,4.2-2.2,5.4-4.4c0.9-1.6,1.7-3.3,2.6-5.3c5.2,7.6,8.1,15.9,9.2,24.7 c2.9,21.9-3.2,42-12.3,61.5c-1,2-2.3,3.9-3,6c-1.4,4.2-4,4.2-7.6,3c-6.1-2.1-10.8-6.1-14.6-11.2c-7.1-9.5-11.6-20.3-15.7-31.3 c-5.7-15.4-11.9-30.7-15.3-46.9c-3.4-16.4-2.3-32.3,7.1-46.8c2-3.1,4.2-5.9,7-8.2c3.5-2.9,5.3-6.5,6.1-10.8 c1.9-10.6,0.5-20.5-7.8-28.3c-5.2-5-10.3-4.8-15.5,0.2C58.51,158.64,56.31,163.74,53.71,169.14z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a14",
    begin: "a12.end",
    fill: "freeze",
    attributeName: "d",
    to: "M64.61,119.42c8.2,2.6,13,8.6,16.1,16.4c6.5,16.6,13.1,33.1,19.7,49.7c3.2,8,7.3,15.6,11.1,23.3 c3.8,7.8,7,15.8,5.7,24.8c-0.4,2.5-1.3,4.8-2.8,6.8c-2,2.5-2.4,5.4-2.5,8.5s1.3,5.4,4.4,6.1c3,0.8,5.1-0.8,6.5-3.2 c0.8-1.4,1.3-2.9,2.1-4.7c3.5,4,5.1,8.9,6.2,13.8c2.9,12.4,3.5,24.9,0.3,37.4c-1.9,7.3-1.3,14.9-2.4,22.3 c-0.6,3.9-1.3,7.6-3.2,11.1c-4.2,7.8-12.4,9.6-19.5,4.1c-6.3-4.8-10.6-11.3-14.4-18c-14.2-25.3-24.9-52-30.6-80.4 c-4.4-22.1-2-44,4.8-65.4c0.1-0.3,0.4-0.6,0.7-1.3c2.7,3.4,6.5,3.8,10.3,3.8c1.1,0,2.4,0.2,1.8-1.7c-2.2-6.7-1.3-13.6-0.7-20.4 c0.9-9.2-2.7-16.6-9.1-22.8c-4.3-4.1-8.9-4-13.3,0.1c-4.5,4.2-6.9,9.7-9.3,15.2c-0.6,1.5-1.2,2.9-1.9,4.7 c-1.2-12.6,3.7-23.8,13.1-30.1C60.11,119.42,62.31,119.42,64.61,119.42z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F756",
    d: "M73.81,177.32c1.7,0,2.2,1.5,2.9,2.6c8.8,13.4,17.5,26.9,26.3,40.3c1,1.6,1.9,3.1,2.7,4.7 c3.5,6.9,3.5,8.1-1.8,13.4c-5,5-4.2,11.5-3.3,17.9c1.3,8.3,5.1,14.7,12.6,17.1c1,0.3,2.2,1.4,3.1,0.1c0.7-1.1,0.2-2.5-0.1-3.7 c-0.1-0.7-0.6-1.3-0.8-1.9c-0.2-0.7-0.8-1.2-0.4-1.9c7.3,4.3,12.5,15.1,11.2,24.5c-1.1,8-1.5,15.9-0.5,23.9 c0.7,5.8-0.1,11.4-2.9,16.5c-3,5.5-6,6.8-11.3,4.7c-7.4-2.9-11.8-9.7-15.6-16.8c-7.6-14.1-11.9-29.7-16.9-45.2 c-4.4-13.9-8.1-27.9-8.4-42.7c-0.1-5.1,0.2-10,1.4-14.8c1.5-6.1,3.7-7.5,9-5.7c2.2,0.8,2.7-0.3,2.7-2.5c-0.1-3.2-0.9-6.3-1.9-9.2 C79.21,191.22,76.61,184.42,73.81,177.32z"
  }, /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a1",
    begin: "0ms;a14.end",
    fill: "freeze",
    attributeName: "d",
    to: "M114.69,338.48c0,0-9.9,3.2-15.7-38.2c-5.8-41.4-28.4-42.2-27-69.4c1.4-27.2,9.2,6.3,12.5-9.6 c3.3-15.9,0.8-33.8,3.3-30.9c2.5,2.9,5.4,19.2,7.9,51s23.9,30.9,24.2,25.5S143.59,334.48,114.69,338.48z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a2",
    begin: "a1.end",
    fill: "freeze",
    attributeName: "d",
    to: "M114.58,338.9c0,0-16.9,2.9-21.6-22.2c-4.8-25.1-3.7-42.1-15.5-54.4s-18.7-50-13.7-56.5 c4.9-6.6,8.2,26.3,11.5,23.8s-0.8-9.4,6.6,2.8c7.5,12.2,10.7,14.6,18.5,8.7c0,0,11.3-9.9,17.6,37.6S120.28,339.3,114.58,338.9z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a3",
    begin: "a2.end",
    fill: "freeze",
    attributeName: "d",
    to: "M107.77,336.33c0,0-20.3-6.6-21.8-34.8c-1.6-28.2-3.4-41.7-14.5-50.9c-11.1-9.3-18.5-68.5-6.9-49.1 s6.5,0.8,11.6,11.4c5,10.7,7.2,26.8,17.6,13.2s7.2-6.5,15.8,14.4c8.6,20.8-0.7,57.5,4,71.1 C118.07,325.33,122.07,343.83,107.77,336.33z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a4",
    begin: "a3.end",
    fill: "freeze",
    attributeName: "d",
    to: "M115.64,338.67c0,0-14.2,5.7-25-30.5c-10.8-36.3,0-54.6-12.3-65.1s-21.8-33.6-17.1-45 c4.7-11.5,7.2-5.9,11.5,5.5c4.2,11.5,17,31.4,20.4,19.5s-5.9-38.5,11.9-9.5s7.2,48.5,10.8,64.2 C119.24,293.47,130.24,341.07,115.64,338.67z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a5",
    begin: "a4.end",
    fill: "freeze",
    attributeName: "d",
    to: "M113.68,338.81c0,0-17.5,4-27.5-24.4s-17.9-45.9-15.4-65.3s-3.9-39.1-9.7-46.7c-5.8-7.6-11.8-23.7,8.6,6.5 s27.3,2.2,26.9-3.2c-0.4-5.4,5.7-16.2,7.2,10s-0.2,44.9,10,67.1C123.88,305.11,133.68,340.21,113.68,338.81z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a6",
    begin: "a5.end",
    fill: "freeze",
    attributeName: "d",
    to: "M115.5,339c0,0-26.9-0.3-32.5-28.7c-5.6-28.4-22.9-42.7-18.7-71.7s-17.4-51.9-10.6-46 c6.8,5.9,20.9,37.7,33.1,21.7c12.2-16.1,0.4,0,8.1,17.8C102.5,250,143.3,337.6,115.5,339z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a7",
    begin: "a6.end",
    fill: "freeze",
    attributeName: "d",
    to: "M115.05,338.88c0,0-17.7,2.7-24.5-17.7c-6.8-20.3-32-63.2-22.6-79.1c9.4-15.8-7.6-43.9-9.5-45.8 c-1.8-1.8-9.6-17.4,10.5,9.6s26.1,7.3,27.5,0.9s4.6-1.4,1.4,18.8C94.75,245.88,153.75,322.88,115.05,338.88z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a8",
    begin: "a7.end",
    fill: "freeze",
    attributeName: "d",
    to: "M92.58,324.3c0,0-21.4-25.1-26.3-61c-4.9-35.9,3.6-41.2,0-50.4c-3.6-9.2,19,21.6,23.1,3s0,16.4,15.8,32.8 s29.6,67.3,16.7,90.2C121.98,339,113.18,327.4,92.58,324.3z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a9",
    begin: "a8.end",
    fill: "freeze",
    attributeName: "d",
    to: "M89.51,314.49c0,0-17.7-23.2-19.8-48.3c-2.1-25.2,1.2-47.4-2.5-54s22.2,16.9,22.3,6.2 c0-10.7,3.3,6.6,7.9,12c4.5,5.4,34.4,35.5,23.4,103.9C120.71,334.19,98.91,301.59,89.51,314.49z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a10",
    begin: "a9.end",
    fill: "freeze",
    attributeName: "d",
    to: "M83.51,284.91c0,0-18.5-23.2-14.4-46.2s2.9-31.9-0.6-36.6s21.7,14.2,27.4,0c5.7-14.2,29.9,39.5,27.5,80.3 c-2.4,40.7,0.5,55.3,0.5,55.3s-11.8,5-12.3-16.9C111.51,320.71,98.41,271.91,83.51,284.91z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a11",
    begin: "a10.end",
    fill: "freeze",
    attributeName: "d",
    to: "M123.54,312.9c-2.3,9.1-3.5,17-7,26.1c-4.8-11-17.6-59.7-34.2-47.1c-1.7-10.5-6.2-20.1-8.8-30.2 c-3.7-19.5,5.3-39.9,16.5-55.5c3.4-4.3,4.4-4.3,6.9,0.4c3.8,6.9,7.4,13.9,11.3,20.7c5.8,10.1,7.7,21.2,8.6,32.6 C117.74,277.9,125.34,294.7,123.54,312.9z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a12",
    begin: "a11.end",
    fill: "freeze",
    attributeName: "d",
    to: "M94.09,199.5c5.7,8.7,8.3,18.5,10.4,28.4c2.7,12.8,5.1,25.7,7.6,38.5c0.1,0.6,0.3,1.2,0.5,1.8 c0.8,2.6,1.1,6.3,4.2,6.4c3.3,0,2.9-3.8,3.4-6.2c0.4-2.1,1.1-1.9,2.3-0.8c4.3,3.8,7.4,8.7,5.7,14.2c-3.8,12.4-3.4,25.4-6.5,37.9 c-1.4,5.4-3.4,10.7-5.2,16c-1.1,3.2-2.4,2.7-4.5,1.2c-5.6-3.8-9-9.3-12-15c-6.5-12.5-10.4-25.9-14.2-39.3c-2.3-8.3-5.1-16.4-6.3-25 c-1.3-9.4-0.3-18.5,3.8-27C88.09,220.6,92.69,210.7,94.09,199.5z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a13",
    begin: "a12.end",
    fill: "freeze",
    attributeName: "d",
    to: "M86.61,212.34c8.2,6.7,12.3,15.6,13.5,25.8c1.2,10.9,0.5,21.9,3.8,32.6c1.7,5.7,3.1,11.6,5.9,16.9 c0.8,1.5,1.7,3.5,3.7,3.1s2.1-2.6,2.4-4.3c1.6-7.7-0.1-15.4-0.4-23.4c1.9,1.3,3,3.2,4,5c4,7.1,5.4,15,6,23 c0.9,13-0.4,25.9-4.2,38.5c-0.4,1.2-0.8,2.4-1.3,3.5c-2.7,6.6-6.1,7.6-12.1,3.6c-5.1-3.4-8.4-8.6-11.2-13.9 c-8.8-16.7-15.4-34.1-18-52.8c-0.8-5.8-0.7-11.7,1.2-17.4c1.4-4.5,3.6-8.5,8-10.9c2.5-1.4,3.3-3.5,3.4-6.2 c0.3-6.4-1.6-12.3-3.5-18.3C87.21,215.74,86.21,214.14,86.61,212.34L86.61,212.34z"
  }), /*#__PURE__*/React.createElement("animate", {
    dur: "50ms",
    id: "a14",
    begin: "a12.end",
    fill: "freeze",
    attributeName: "d",
    to: "M73.81,177.32c1.7,0,2.2,1.5,2.9,2.6c8.8,13.4,17.5,26.9,26.3,40.3c1,1.6,1.9,3.1,2.7,4.7 c3.5,6.9,3.5,8.1-1.8,13.4c-5,5-4.2,11.5-3.3,17.9c1.3,8.3,5.1,14.7,12.6,17.1c1,0.3,2.2,1.4,3.1,0.1c0.7-1.1,0.2-2.5-0.1-3.7 c-0.1-0.7-0.6-1.3-0.8-1.9c-0.2-0.7-0.8-1.2-0.4-1.9c7.3,4.3,12.5,15.1,11.2,24.5c-1.1,8-1.5,15.9-0.5,23.9 c0.7,5.8-0.1,11.4-2.9,16.5c-3,5.5-6,6.8-11.3,4.7c-7.4-2.9-11.8-9.7-15.6-16.8c-7.6-14.1-11.9-29.7-16.9-45.2 c-4.4-13.9-8.1-27.9-8.4-42.7c-0.1-5.1,0.2-10,1.4-14.8c1.5-6.1,3.7-7.5,9-5.7c2.2,0.8,2.7-0.3,2.7-2.5c-0.1-3.2-0.9-6.3-1.9-9.2 C79.21,191.22,76.61,184.42,73.81,177.32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.314943e8bfa7203475c32ae70f70dd8a.svg";
export { ForwardRef as ReactComponent };